export enum EvaluationSupplierEnum {
	ToEvaluate = 1,
	Evaluated = 2,
	NotAvailable = 3,
}
